
import { Component, Emit, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import {
  fetchLineRefresh,
  fetchLineMessage,
  fetchMghrwcToken,
} from "@/services/userService";
import { isVisibleAlignmentAlert } from "@/lib/functions";
import ButtonSwitchCorporate from "./ButtonSwitchCorporate.vue";

@Component({
  components: {
    ButtonSwitchCorporate,
  },
})
export default class HomeAlignment extends Vue {
  private name = "HomeAlignment";
  private viewStatus = 0;
  private lineAlignment = false;
  private mghAlignment = false;
  private forgetMghrwcPwUrl = `${process.env.VUE_APP_MGHRWC_DOMAIN}${process.env.VUE_APP_MGHRWC_FORGET_PASSWORD_URL}`;
  private signUpMghrwcUrl = `${process.env.VUE_APP_MGHRWC_DOMAIN}${process.env.VUE_APP_MGHRWC_CREATE_ACCOUNT_URL}`;
  private mghrwcReservedUrl = `${process.env.VUE_APP_OPTIMA_RESERVATION_URL}/ja/reservations/detail_entry`;

  get visibleAlertAlignment(): boolean {
    return isVisibleAlignmentAlert(store.getters["auth/group"]);
  }

  @Emit()
  private async refreshLine() {
    await store.dispatch("auth/lineRefresh");
  }

  @Emit()
  private logoutMessage() {
    fetchLineMessage({ slug: "logout" });
  }

  @Emit()
  private optimaCSSOToken() {
    fetchMghrwcToken({ action: "clubno", lang: "ja-JP" })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  @Emit()
  private deleteLine() {
    store.dispatch("auth/lineDelete");
  }

  @Emit()
  private handlerLineAuth() {
    this.$router.push({
      path: "/line-auth",
      query: {
        from: this.$route.fullPath,
      },
    });
  }

  @Emit()
  private handlerOpenMghrwcModal() {
    store.commit("modalMghrwc/open");
  }

  @Emit()
  private clickMghrwcLabel() {
    if (!this.lineAlignment) {
      this.handlerLineAuth();
    } else {
      this.handlerOpenMghrwcModal();
    }
  }

  @Watch("viewStatus")
  private onChangeViewStatus() {
    switch (this.viewStatus) {
      case 1:
        this.lineAlignment = true;
        this.mghAlignment = false;
        break;
      case 2:
        this.lineAlignment = true;
        this.mghAlignment = true;
        break;
      default:
        this.lineAlignment = false;
        this.mghAlignment = false;
        break;
    }
  }

  get lineAccessToken(): string {
    if (store.getters["auth/line"]) {
      return store.getters["auth/line"].access_token;
    }
    return "";
  }

  get lineIdToken(): string {
    if (store.getters["auth/line"]) {
      return store.getters["auth/line"].id_token;
    }
    return "";
  }

  @Emit()
  private updateUser() {
    const line = store.getters["auth/line"];
    const mghrwc = store.getters["auth/mghrwc"];
    if (line && !mghrwc) {
      this.viewStatus = 1;
      return;
    }
    if (line && mghrwc) {
      this.viewStatus = 2;
      return;
    }
    this.viewStatus = 0;
  }

  @Watch("$store.state.auth", { immediate: true, deep: true })
  private onChangeAuthLine() {
    this.updateUser();
  }

  get loginCompany(): string {
    if (this.lang === "en") {
      return store.getters["auth/nameEn"];
    } else {
      return store.getters["auth/name"];
    }
  }
}
